import React from 'react';
import { ReloadMediumIcon, RotatingReloadIcon } from 'assests/GmsIcons';

type ReloadButtonProps = {
    loading: boolean;
    onClick: () => void;
}

const ReloadButton = ({ loading, onClick } : ReloadButtonProps) => {

    return (
        <button className={`w-8 h-8 py-2 px-2 rounded border border-[#091caa] flex justify-center items-center ${loading ? 'bg-gray-200' : 'bg-white'}`} disabled={loading} onClick={onClick}>
            {loading ? (<RotatingReloadIcon />) : (<ReloadMediumIcon /> )}
        </button>
    );
}

export default ReloadButton;